import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, Typography, Box } from "@mui/material";
import DateTime from "../../../../../vendor/luxon/src/datetime.js";
import "../../../../../vendor/luxon/src/duration.js";
import { useMemo } from "react";
import SvgArrow from "./arrow.svg.js";
import SvgArrowSmall from "./arrow_small.svg.js";
import { IconButton } from "../../../../IconButtonNew/IconButton.js";
import { inheritDataTestId } from "../../../../../utils/dataTestId.js";
const CalendarHeader = ({
  date,
  onClick,
  toggleMonthYear,
  onNext,
  onPrev,
  back,
  type,
  disabledTo,
  disabledFrom,
  readonly,
  ...props
}) => {
  const selectedMonthDate = date, { disablePrev, disableNext } = useMemo(() => {
    const date2 = DateTime.fromISO(selectedMonthDate).startOf("month");
    let diffFrom = 0, diffTo = 0;
    disabledFrom && (diffFrom = date2.diff(
      DateTime.fromISO(disabledFrom).startOf("month"),
      "month"
    ).months), disabledTo && (diffTo = date2.diff(
      DateTime.fromISO(disabledTo).startOf("month"),
      "month"
    ).months);
    const disableNext2 = disabledFrom ? diffFrom >= 0 : !1;
    return { disablePrev: disabledTo ? diffTo <= 0 : !1, disableNext: disableNext2 };
  }, [disabledFrom, disabledTo, selectedMonthDate]), renderButton = (title, onClick2, icon) => /* @__PURE__ */ jsxs(
    IconButton,
    {
      "data-test-id": inheritDataTestId(props, "title-button"),
      sx: styles.titleButton,
      size: "xs",
      color: "secondary",
      onClick: () => {
        onClick2(void 0);
      },
      children: [
        /* @__PURE__ */ jsx("span", { children: title }),
        icon
      ]
    }
  ), renderTitle = (date2, icon) => {
    const isRangeHeader = ["left", "right", "middle"].includes(type), dateObj = DateTime.fromISO(date2);
    if (!isRangeHeader)
      return renderButton(
        dateObj.toFormat("MMMM yyyy"),
        () => {
          !readonly && onClick(date2);
        },
        icon && !readonly && /* @__PURE__ */ jsx(SvgArrowSmall, {})
      );
    const monthButton = renderButton(dateObj.toFormat("MMMM"), () => {
      !readonly && toggleMonthYear("month");
    }), yearButton = renderButton(dateObj.toFormat("yyyy"), () => {
      !readonly && toggleMonthYear("year");
    });
    return /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: 12, children: [
      monthButton,
      yearButton
    ] });
  }, renderBackBt = (cb, back2) => /* @__PURE__ */ jsx(
    IconButton,
    {
      size: "lg",
      color: "secondary",
      onClick: cb,
      disabled: back2 ? !1 : disablePrev,
      "data-test-id": inheritDataTestId(props, "back-button"),
      children: /* @__PURE__ */ jsx(Box, { component: SvgArrow })
    }
  ), renderForwardBt = (cb) => /* @__PURE__ */ jsx(
    IconButton,
    {
      size: "lg",
      color: "secondary",
      onClick: cb,
      disabled: disableNext,
      "data-test-id": inheritDataTestId(props, "forward-button"),
      children: /* @__PURE__ */ jsx(Box, { component: SvgArrow, sx: { transform: "rotate(180deg)" } })
    }
  );
  return type === "single" ? /* @__PURE__ */ jsxs(Stack, { sx: [styles.container, { paddingLeft: 14 }], direction: "row", children: [
    /* @__PURE__ */ jsx(Stack, { sx: [styles.titleContainer, { alignItems: "start" }], children: renderTitle(date, !0) }),
    !readonly && renderBackBt(onPrev),
    !readonly && renderForwardBt(onNext)
  ] }) : type === "left" ? /* @__PURE__ */ jsxs(Stack, { sx: styles.container, direction: "row", children: [
    renderBackBt(onPrev),
    /* @__PURE__ */ jsx(Stack, { sx: styles.titleContainer, children: renderTitle(date) }),
    /* @__PURE__ */ jsx(IconButton, { size: "lg", color: "secondary", "data-test-id": void 0 })
  ] }) : type === "middle" ? /* @__PURE__ */ jsxs(Stack, { sx: styles.container, direction: "row", children: [
    /* @__PURE__ */ jsx(IconButton, { size: "lg", color: "secondary", "data-test-id": void 0 }),
    /* @__PURE__ */ jsx(Stack, { sx: styles.titleContainer, children: renderTitle(date) }),
    /* @__PURE__ */ jsx(IconButton, { size: "lg", color: "secondary", "data-test-id": void 0 })
  ] }) : type === "right" ? /* @__PURE__ */ jsxs(Stack, { sx: styles.container, direction: "row", children: [
    /* @__PURE__ */ jsx(IconButton, { size: "lg", color: "secondary", "data-test-id": void 0 }),
    /* @__PURE__ */ jsx(Stack, { sx: styles.titleContainer, children: renderTitle(date) }),
    renderForwardBt(onNext)
  ] }) : /* @__PURE__ */ jsxs(Stack, { sx: styles.container, direction: "row", children: [
    renderBackBt(back, !0),
    /* @__PURE__ */ jsx(Stack, { sx: styles.titleContainer, children: type === "month" ? /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: 8, children: [
      /* @__PURE__ */ jsx(Typography, { sx: styles.inactiveText, children: "Month" }),
      renderButton("Year", toggleMonthYear)
    ] }) : /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: 8, children: [
      renderButton("Month", toggleMonthYear),
      /* @__PURE__ */ jsx(Typography, { sx: styles.inactiveText, children: "Year" })
    ] }) }),
    /* @__PURE__ */ jsx(IconButton, { size: "lg", color: "secondary", "data-test-id": void 0 })
  ] });
}, styles = {
  inactiveText: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    color: "common.white"
  },
  container: {
    backgroundColor: (t) => t.palette.picker.primary.header,
    width: "100%",
    height: 48,
    alignItems: "center",
    paddingX: 3,
    boxSizing: "border-box"
  },
  titleContainer: {
    flex: "0 1 100%",
    alignItems: "center",
    justifyContent: "center",
    color: "white"
  },
  title: {
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: 600,
    color: (t) => t.palette.content.accent.secondary
  },
  titleButton: {
    width: "auto",
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: 600,
    color: (t) => t.palette.content.accent.secondary,
    display: "flex",
    gap: 5
  }
};
export {
  CalendarHeader
};
//# sourceMappingURL=CalendarHeader.js.map
